import { isIOS } from 'utils/environment';
import axios from 'axios';

export const pendingRequestMap = new Map();

function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }
  // 其实就外层保存resolve方法
  let resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  let token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = message;
    // 在这里调用resolve方法，用于改变Promise状态
    resolvePromise(token.reason);
  });
}

export const getFetchKey = (config) => {
  if (!(config || {}).url) {
    return null;
  }
  const { url, data, method, params } = config;
  if (method === 'get') {
    return [method, url, JSON.stringify(params || '{}')].join('&');
  } else {
    return [method, url, typeof data === 'string' ? data : JSON.stringify(data)].join('&');
  }
};

export const addPending = (config) => {
  const fetchKey = getFetchKey(config);
  if (fetchKey) {
    if (!pendingRequestMap.has(fetchKey)) {
      if (config.nativeBusinessFlag && isIOS()) {
        return new CancelToken((cancel) => {
          pendingRequestMap.set(fetchKey, cancel);
        });
      } else {
        config.cancelToken = new axios.CancelToken((cancel) => {
          pendingRequestMap.set(fetchKey, cancel);
        });
      }
    }
  }
  return null;
};

export const removePending = (config) => {
  const fetchKey = getFetchKey(config);
  if (fetchKey) {
    if (pendingRequestMap.has(fetchKey)) {
      pendingRequestMap.delete(fetchKey);
    }
  }
};

export const clearPending = () => {
  if (pendingRequestMap.size) {
    let pendingArr = pendingRequestMap.values();
    let current = pendingArr.next();
    while (!current.done) {
      current.value('hly-cancel-交易失败');
      current = pendingArr.next();
    }
    pendingRequestMap.clear();
  }
};

export const clearTargetPending = (url) => {
  if (pendingRequestMap.size) {
    let pendingArr = pendingRequestMap.values();
    let nameArr = pendingRequestMap.keys();
    let current = pendingArr.next();
    let name = nameArr.next().value;
    while (!current.done) {
      let temp = name.split('&');
      if (url.includes(temp[1])) {
        current.value('hly-cancel-交易失败');
        pendingRequestMap.delete(name);
      }
      current = pendingArr.next();
      name = nameArr.next().value;
    }
  }
};
